import React, { useState } from 'react';
import VideoPlayer from 'app/components/VideoPlayer';

import { FormItemVideo } from '../types';

interface ContactFormVideoProps {
  item: FormItemVideo;
}

export function ContactFormVideo({ item }: ContactFormVideoProps) {
  const [playing, setPlaying] = useState(false);
  const { url, placeholder_image_url, video_name, title } = item;

  return (
    <>
      <input
        type="hidden"
        name={item.ref_id}
        value="true"
      />
      <div className="max-w-full mb-4">
        <VideoPlayer
          title={title}
          url={url}
          video_name={video_name}
          controls
          muted
          width="100%"
          height="180px"
          className="overflow-hidden"
          light={placeholder_image_url}
          playing={playing}
          onClickPreview={(e) => {
            e.stopPropagation();
            setPlaying(true);
          }}
        />
      </div>
    </>
  );
}
